<button id="{{internalid}}" [disabled]="disabled" class="{{class}}" (click)="click()">
    <mat-icon *ngIf="icon">{{icon}}</mat-icon>
    <ng-container *ngIf="!showLoader && !showLoaderWithText">
        {{ text }}
    </ng-container>
    <mat-icon [class.only__icon]="!text" *ngIf="altIcon">{{altIcon}}</mat-icon>
    <div *ngIf="showLoader" class="content__loading">
        <div class="loading"></div>
    </div>
    <div *ngIf="showLoaderWithText" class="spinner__text">
        <mat-spinner [diameter]="20" mode="indeterminate"></mat-spinner>
        <p>{{ text }}</p>
    </div>
    <span *ngIf="showNotification" class="notification">1</span>
</button>
